import { Action, createReducer, on } from '@ngrx/store';
import { CanPayResults } from '../enums/can-pay-response.enum';
import {
  checkCanPayErrorAction,
  checkCanPaySuccessAction,
  deletePaymentCardAction,
  deletePaymentCardErrorAction,
  deletePaymentCardSuccessAction,
  loadPaymentCardsAction,
  loadPaymentCardsErrorAction,
  loadPaymentCardsSuccessAction,
  selectPaymentCardAction,
} from './payment-cards.actions';
import { PaymentCardsState } from './payment-cards.state';

const initialState = new PaymentCardsState();

const reducer = createReducer(
  initialState,
  on(loadPaymentCardsAction, (state) => {
    const newState = { ...state };
    newState.isLoading = true;
    return newState;
  }),
  on(loadPaymentCardsSuccessAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.paymentCards = payload.paymentCards;
    return newState;
  }),
  on(loadPaymentCardsErrorAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = payload.failure;
    return newState;
  }),
  on(checkCanPaySuccessAction, (state) => {
    const newState = { ...state };
    newState.canPay = CanPayResults.Yes;
    newState.isLoading = false;
    return newState;
  }),
  on(checkCanPayErrorAction, (state, payload) => {
    const newState = { ...state };
    newState.canPay = payload.canPayStatus;
    newState.isLoading = false;
    return newState;
  }),
  on(selectPaymentCardAction, (state, payload) => {
    const newState = { ...state };
    newState.selectedPaymentCard = payload.paymentCard;
    return newState;
  }),
  on(deletePaymentCardAction, (state) => {
    const newState = { ...state };
    newState.isLoading = true;
    return newState;
  }),
  on(deletePaymentCardSuccessAction, (state) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.deletedPaymentSuccess = {success: true};
    return newState;
  }),
  on(deletePaymentCardErrorAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = payload.failure;
    return newState;
  })
);

export function paymentCardsReducer(state: PaymentCardsState | undefined, action: Action) {
  return reducer(state, action);
}
